import styled from 'styled-components';

export const Item = styled.div`
  text-align: center;
  margin-left: 2px;
`;

export const Value = styled.div`
  min-width: 21px;
  border-radius: 5px;
  padding: 2px 4px;
  font-weight: 700;
  font-size: 10.5px;
  line-height: 1;
  transition: all 0.15s ease;
  border: 1px solid ${(props) => (props.$active ? '#5cc98a' : '#2c353d')};
  background: ${(props) => (props.$active ? '#2f9457' : '#1a2429')};
  color: ${(props) => (props.$active ? '#f2fff7' : '#7a838a')};
  box-shadow: ${(props) => (props.$active ? '0 0 7px rgba(71, 185, 114, 0.45)' : 'none')};
`;

export const Title = styled.div`
  color: inherit;
  font-weight: 700;
  font-size: 11px;
  line-height: 1;
`;
